module.exports = __webpack_public_path__ + "img/vmc_aniv19_24Aug2021.65d658fe.jpg";